const sidebarMenu = [
    {
        name: "HORDE",
        options: {},
        items: [
            { path: '/dashboard', icon: 'fa fa-sitemap', title: 'Dashboard'},
        ],
    },
];
export default sidebarMenu;